import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

const MetamenuItem = lazy(() =>
	import(/* webpackChunkName: "metamenuItem" */ "./metamenuItem")
);

const useStyles = makeStyles(theme => ({
	metamenu: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		[theme.breakpoints.up("md")]: {
			alignItems: "center",
			flexDirection: "row"
		},
		[theme.breakpoints.up("lg")]: {
			justifyContent: "flex-start"
		},
		"& ul": {
			display: "flex",
			flexWrap: "wrap",
			justifyContent: "center",
			listStyle: "none",
			margin: theme?.spacing(0, -1),
			order: 1,
			textAlign: "center",
			[theme.breakpoints.up("md")]: {
				order: 2
			}
		}
	},
	copyrights: {
		order: 2,
		[theme.breakpoints.up("sm")]: {
			margin: theme?.spacing(0, 1, 0, 0),
			order: 1
		},
		...theme?.customTypography?.footer02?.metamenu?.mobile?.level1,
		[theme.breakpoints.up("lg")]: {
			...theme?.customTypography?.footer02?.metamenu?.desktop?.level1
		}
	}
}));

const Metamenu = ({ copyrights, metamenu }) => {
	const css = useStyles();

	return (
		<div className={clsx("mco-footer-02__metamenu", css.metamenu)}>
			{copyrights && (
				<Typography className={clsx("mco-footer-02__metamenu__copyrights", css.copyrights)}>
					{copyrights}
				</Typography>
			)}
			<ul>
				{metamenu?.items?.map(item => {
					return (
						<li key={item.id}>
							<Suspense fallback={<></>}>
								<MetamenuItem
									icon={item.icon?.filename}
									level={1}
									link={item.link}
									selected={item.selected}
									target={item.target}
									title={item.title}
								/>
							</Suspense>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

Metamenu.propTypes = {
	copyrights: PropTypes.string,
	metamenu: PropTypes.object.isRequired
};

export default Metamenu;
